// Tiny WebAudio synth: placeholder SFX with zero asset weight.
import type { Game } from '../game/game';

export class Sfx {
  private ctx: AudioContext | null = null;

  constructor(private isMuted: () => boolean) {}

  private beep(freq: number, dur: number, type: OscillatorType = 'square', vol = 0.05, slide = 0): void {
    if (this.isMuted()) return;
    try {
      this.ctx ??= new AudioContext();
      const t = this.ctx.currentTime;
      const o = this.ctx.createOscillator(), g = this.ctx.createGain();
      o.type = type;
      o.frequency.setValueAtTime(freq, t);
      if (slide) o.frequency.exponentialRampToValueAtTime(Math.max(40, freq + slide), t + dur);
      g.gain.setValueAtTime(vol, t);
      g.gain.exponentialRampToValueAtTime(0.0001, t + dur);
      o.connect(g).connect(this.ctx.destination);
      o.start(t);
      o.stop(t + dur);
    } catch { /* audio unavailable */ }
  }

  bind(game: Game): void {
    const e = game.events;
    e.on('damage', (d) => {
      if (d.crit) this.beep(520, 0.12, 'sawtooth', 0.04, -300);
      else if (d.source === 'tap') this.beep(180 + Math.random() * 60, 0.06, 'square', 0.03, -80);
    });
    e.on('kill', () => { this.beep(988, 0.06, 'sine', 0.04); setTimeout(() => this.beep(1319, 0.08, 'sine', 0.04), 50); });
    e.on('purchase', () => this.beep(660, 0.08, 'triangle', 0.05, 200));
    e.on('spawn', (s) => { if (s.monster.boss) this.beep(110, 0.5, 'sawtooth', 0.06, -50); });
    e.on('skillUsed', () => this.beep(300, 0.3, 'triangle', 0.06, 600));
    e.on('bossFailed', () => this.beep(220, 0.5, 'triangle', 0.06, -150));
  }
}
